import { FC } from 'react'
import style from './style.m.less'
import moment from 'moment'
import { DropdownSelector2, TimeRangePicker, DatePicker } from '../../../ui'

interface IFilter {
    onChange: (data: string | number | number[], key: string, obj?: any) => void
    owners: any
    isOpen: boolean
}

const statusIds = [
    { id: 3, name: 'Отказана' },
    { id: 4, name: 'Согласована' },
]

const Filter: FC<IFilter> = ({ onChange, owners, isOpen }) => {
    const updateFilters = (data: any, key: string) => {
        switch (key) {
            case 'date':
                return onChange('', '', {
                    ts_created: data ? moment.utc(data).format() : undefined,
                })
            case 'rangeReport':
                return onChange('', '', {
                    ts_from: data ? moment(data[0]).startOf('day') : undefined,
                    ts_to: data ? moment(data[1]).endOf('day') : undefined,
                })
            case 'statuses':
                if (!data.length) {
                    return onChange([3, 4], 'statuses')
                } else {
                    return onChange(data, key)
                }
            default:
                return onChange(data, key)
        }
    }

    const filterWidth = { width: isOpen ? '400px' : '296px' }

    const options = (owners?.go_owners || []).map((item: any) => ({
        text: item.company_name_short,
        value: item.uid,
        id: item.uid,
        key: item.uid,
    }))

    return (
        <div className={style.filter}>
            <div className={style.filterItem}>
                <div className={style.label}>Отчетный период</div>
                <TimeRangePicker
                    style={filterWidth}
                    onChange={(value) => updateFilters(value, 'rangeReport')}
                />
            </div>
            <div className={style.filterItem}>
                <div className={style.label}>Владелец ЗГО</div>
                <DropdownSelector2
                    onChange={(tid) => {
                        updateFilters(tid, 'uid')
                    }}
                    options={options}
                    customStyle={filterWidth}
                    placeholder={'Все'}
                    noDefaultValue
                    allowClear
                />
            </div>
            <div className={style.filterItem}>
                <div className={style.label}>Дата подачи заявки</div>
                <DatePicker
                    customStyle={filterWidth}
                    onChange={(value) => updateFilters(value, 'date')}
                    format={'DD.MM.YYYY'}
                />
            </div>
            {!isOpen && (
                <div className={style.filterItem}>
                    <div className={style.label}>Статус</div>
                    <DropdownSelector2
                        onChange={(tid) => {
                            updateFilters(tid, 'statuses')
                        }}
                        options={statusIds.map((item: any) => {
                            return {
                                text: item.name,
                                value: item.id,
                                id: item.id,
                                key: item.id,
                            }
                        })}
                        customStyle={filterWidth}
                        placeholder={'Все'}
                        noDefaultValue
                        isMultiple
                        allowClear
                    />
                </div>
            )}
        </div>
    )
}

export default Filter
